import { typedI18nFactory } from '../../lib/typedI18nFactory';
import { en } from './en';
import { ru } from './ru';

export const i18n = typedI18nFactory({ ru, en });
